import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

const { carbon } = colorsPalettes;

export const ChartDelimiter = styled.div`
    width: 100%;
    border-bottom: 1px solid ${carbon[50]};
`;
